import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "ec8526f3-be66-44d9-adfd-86c79787f395",
    content: "Microphone weights<br>do not depend on frequency.",
    options: {},
  },
  { id: "9df97eb8-0a44-4aff-ae8d-a4cabb4768aa", content: "They use the<br>“delay and sum” principle.", options: {} },
  { id: "626e005c-335e-40c3-b722-bc5d7b9f9989", content: "They exhibit a high SNR<br>at low frequency.", options: {} },
  { id: "a971bf3e-e38c-4d46-a163-eca4a1de2086", content: "They only work<br>for linear arrays.", options: {} },
  { id: "9660d9d0-3341-49be-8fc8-7179b472630c", content: "They are well suited<br>for compact arrays.", options: {} },
  {
    id: "2b3af1c6-b841-4eb8-82bb-577fae86b3da",
    content: "They generally use a first<br>or second order beampattern.",
    options: {},
  },
];

export const task: Task = {
  id: "11371dc4-fa54-402a-90dc-204dd699de18",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["9660d9d0-3341-49be-8fc8-7179b472630c", "2b3af1c6-b841-4eb8-82bb-577fae86b3da"],
};
